import { useEffect, useState } from "react";
import {
  FAVORITES_KEY,
  FAVORITES_LIMIT,
  locationKey,
  normalizeLocation,
  readFavorites,
} from "../lib/locations";

export default function useFavorites() {
  const [favorites, setFavorites] = useState(readFavorites);
  const [message, setMessage] = useState("");
  useEffect(() => {
    const sync = (event) => {
      if (event.key === FAVORITES_KEY || event.key === null)
        setFavorites(readFavorites());
    };
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);
  const toggle = (location) => {
    const valid = normalizeLocation(location);
    if (!valid) return;
    const current = readFavorites();
    const exists = current.some(
      (item) => locationKey(item) === locationKey(valid),
    );
    if (!exists && current.length >= FAVORITES_LIMIT) {
      setMessage(
        `You can save up to ${FAVORITES_LIMIT} places. Remove one to add another.`,
      );
      return;
    }
    const next = exists
      ? current.filter((item) => locationKey(item) !== locationKey(valid))
      : [...current, valid];
    try {
      window.localStorage.setItem(FAVORITES_KEY, JSON.stringify(next));
      setFavorites(next);
      setMessage(
        exists
          ? "Place removed from favorites."
          : "Place saved on this device.",
      );
    } catch {
      setMessage(
        "This browser could not save favorites. Check your storage settings.",
      );
    }
  };
  return { favorites, toggle, message };
}
